var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRestore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 18.6667C7 19.0167 7.23333 19.25 7.58333 19.25H10.5C10.85 19.25 11.0833 19.0167 11.0833 18.6667V15.75C11.0833 15.4 10.85 15.1667 10.5 15.1667C10.15 15.1667 9.91667 15.4 9.91667 15.75V17.5C9.15833 16.5083 8.75 15.2833 8.75 14C8.75 10.7917 11.375 8.16667 14.5833 8.16667C17.7917 8.16667 20.4167 10.7917 20.4167 14C20.4167 17.2083 17.7917 19.8333 14.5833 19.8333C14.2333 19.8333 14 20.0667 14 20.4167C14 20.7667 14.2333 21 14.5833 21C18.4333 21 21.5833 17.85 21.5833 14C21.5833 10.15 18.4333 7 14.5833 7C10.7333 7 7.58333 10.15 7.58333 14C7.58333 15.4583 8.05 16.9167 8.925 18.0833H7.58333C7.23333 18.0833 7 18.3167 7 18.6667Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestore);
export default __webpack_public_path__ + "static/media/restore.ed08e20a47eb3f25b5cf8c9b33dfbb8a.svg";
export { ForwardRef as ReactComponent };